export const navData = [
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/e2b2795ad9e97a57.png?q=100",
    text: "Mobiles",
    href: "mobiles",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/5c44091c4cde5527.png?q=100",
    text: "Fashion",
    href: "fashion",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/9468f7c638007682.png?q=100",
    text: "Electronics",
    href: "electronics",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/0a4e27792f699b67.png?q=100",
    text: "Home",
    href: "home-items",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/71050627a56b4693.png?q=100",
    text: "Travel",
    href: "travel",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/d42b57d8569fccc3.png?q=100",
    text: "Appliances",
    href: "appliances",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/2a284788d550ac21.png?q=100",
    text: "Furniture",
    href: "furniture",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/db4875975dc033aa.png?q=100",
    text: "Beauty, Toys & More",
    href: "beauty-toy-products",
  },
  {
    url: "https://rukminim1.flixcart.com/flap/128/128/image/d270faabceb32f09.png?q=100",
    text: "Grocery",
    href: "grocery",
  },
];

// ########## Posters ##########################

export const bannerData = [
  "https://rukminim1.flixcart.com/flap/1000/1000/image/5655d35aa959ffe8.jpg",
  "https://rukminim1.flixcart.com/flap/1000/1000/image/c7d2b98b5ac01799.jpg",
  "https://rukminim1.flixcart.com/flap/1000/1000/image/938d2f267807952f.jpg",
  "https://rukminim1.flixcart.com/flap/1000/1000/image/d72cac86423a498b.jpg",
  "https://rukminim1.flixcart.com/flap/1000/1000/image/a9193a4988ff1328.jpg",
  "https://rukminim1.flixcart.com/flap/1000/1000/image/e284b77bb80114f7.jpg",
];

export const posterLinks = {
  links1: [
    "https://rukminim1.flixcart.com/flap/1000/1000/image/4d9c1d1100e04780.jpg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/09e95cc6a5e7c5c3.jpg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/26846f7dbecf8555.jpg?q=50",
  ],

  links2: [
    "https://rukminim1.flixcart.com/flap/1000/1000/image/bf9c7eb4dfe3e778.jpg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/9123cc58a752f8f3.jpg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/89d5eee1f8f1e530.jpeg?q=50",
  ],

  links3: [
    "https://rukminim1.flixcart.com/flap/1000/1000/image/5175bb37d0a7b179.jpg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/e776ee5c8ad1a40b.jpg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/c4c5331fefc5675e.jpg?q=50",
  ],

  links4: [
    "https://rukminim1.flixcart.com/flap/1000/1000/image/f40f2aeeeaffb5c8.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/8ad9432b231a6ff2.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/e44a19df21425913.jpeg?q=50",
  ],

  links5: [
    "https://rukminim1.flixcart.com/flap/1000/1000/image/2a7f67fc8476bec7.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/02f31191fe477de3.jpg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/5d7822bf05bdce34.jpg?q=50",
  ],

  links6: [
    "https://rukminim1.flixcart.com/flap/1000/1000/image/fda0d9fac84f44b2.jpg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/f54b25685a57e491.jpg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/4a362bb3cdbee37d.jpeg?q=50",
  ],
};

// #### Featured Brand Links #######

export const featuredBrandLinks = {
  links1: [
    "https://rukminim1.flixcart.com/flap/1000/1000/image/41f775cacaf178cd.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/e15c92840c1862bb.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/581e55ab215741a1.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/7b68ba8d190bac14.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/6436a0e43e0113c5.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/3de3f47fa1a24923.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/84696bdfa542c3ac.jpeg?q=50",
  ],
  links2: [
    "https://rukminim1.flixcart.com/flap/1000/1000/image/18f398d652bdb15c.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/1e1178e8146d1cde.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/5de6d0d0f0496b13.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/f23ea9fcb08af274.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/acc80e60602c6542.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/a37bf7df0fcacc94.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/b267da4dbf95da06.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/e72b16f6508a1444.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/3b17f8e3d3764d4b.jpeg?q=50",
    "https://rukminim1.flixcart.com/flap/1000/1000/image/85c69bbdd7a71b91.jpeg?q=50",
  ],
};

export const horizontalPosterLink =
  "https://rukminim1.flixcart.com/flap/4000/576/image/e69d03a985bed59b.jpg";

export const sidePosterLink =
  "https://rukminim1.flixcart.com/flap/464/708/image/633789f7def60050.jpg?q=70";

export const maleAvatarUrl =
  "https://static-assets-web.flixcart.com/www/linchpin/fk-cp-zion/img/profile-pic-male_4811a1.svg";

export const femaleAvatarUrl =
  "https://static-assets-web.flixcart.com/www/linchpin/fk-cp-zion/img/profile-pic-female_0627fd.svg";

export const fassured =
  "https://static-assets-web.flixcart.com/www/linchpin/fk-cp-zion/img/fa_62673a.png";

export const emptyWishlist =
  "https://static-assets-web.flixcart.com/www/linchpin/fk-cp-zion/img/mywishlist-empty_39f7a5.png";

export const emptyCartUrl =
  "https://rukminim1.flixcart.com/www/800/800/promos/16/05/2019/d438a32e-765a-4d8b-b4a6-520b560971e8.png?q=90";

export const noOrdersUrl =
  "https://static-assets-web.flixcart.com/www/linchpin/fk-cp-zion/img/emptyOrders_f13d28.png";

export const superCoin =
  "https://rukminim1.flixcart.com/lockin/736/176/images/promotion_banner_v2_inactive_2.png?q=50";

export const shieldIcon =
  "https://static-assets-web.flixcart.com/www/linchpin/fk-cp-zion/img/shield_5f9216.png";

export const indianStates = [
  {
    value: "Andhra Pradesh",
    label: "Andhra Pradesh",
  },
  {
    value: "Assam",
    label: "Assam",
  },
  {
    value: "Bihar",
    label: "Bihar",
  },

  {
    value: "Chhattisgarh",
    label: "Chhattisgarh",
  },
  {
    value: "Goa",
    label: "Goa",
  },
  {
    value: "Gujarat",
    label: "Gujarat",
  },
  {
    value: "Haryana",
    label: "Haryana",
  },
  {
    value: "Himachal Pradesh",
    label: "Himachal Pradesh",
  },
  {
    value: "Jammu and Kashmir",
    label: "Jammu and Kashmir",
  },
  {
    value: "Jharkhand",
    label: "Jharkhand",
  },
  {
    value: "Karnataka",
    label: "Karnataka",
  },
  {
    value: "Kerala",
    label: "Kerala",
  },
  {
    value: "Madhya Pradesh",
    label: "Madhya Pradesh",
  },
  {
    value: "Maharashtra",
    label: "Maharashtra",
  },
  {
    value: "Manipur",
    label: "Manipur",
  },
  {
    value: "Meghalaya",
    label: "Meghalaya",
  },
  {
    value: "Mizoram",
    label: "Mizoram",
  },
  {
    value: "Nagaland",
    label: "Nagaland",
  },
  {
    value: "Odisha",
    label: "Odisha",
  },
  {
    value: "Punjab",
    label: "Punjab",
  },
  {
    value: "Rajasthan",
    label: "Rajasthan",
  },
  {
    value: "Sikkim",
    label: "Sikkim",
  },
  {
    value: "Tamil Nadu",
    label: "Tamil Nadu",
  },
  {
    value: "Telangana",
    label: "Telangana",
  },
  {
    value: "Tripura",
    label: "Tripura",
  },
  {
    value: "Uttarakhand",
    label: "Uttarakhand",
  },
  {
    value: "Uttar Pradesh",
    label: "Uttar Pradesh",
  },
  {
    value: "West Bengal",
    label: "West Bengal",
  },
  {
    value: "Andaman and Nicobar Islands",
    label: "Andaman and Nicobar Islands",
  },
  {
    value: "Chandigarh",
    label: "Chandigarh",
  },
  {
    value: "Dadra and Nagar Haveli",
    label: "Dadra and Nagar Haveli",
  },
  {
    value: "Daman and Diu",
    label: "Daman and Diu",
  },
  {
    value: "Delhi",
    label: "Delhi",
  },
  {
    value: "Lakshadweep",
    label: "Lakshadweep",
  },
  {
    value: "Puducherry",
    label: "Puducherry",
  },
];
